import { dtf, namesAndNumbers, vinyl } from "../../images";

let heatTransfersList = [
  {
    img: dtf,
    title: "DTF",
    alt: "DTF",
  },
  {
    img: vinyl,
    title: "HEAT TRANSFER VINYL",
    alt: "HEAT TRANSFER VINYL",
  },
  {
    img: namesAndNumbers,
    title: "NAMES & NUMBERS",
    alt: "NAMES & NUMBERS",
  },
];
export default heatTransfersList;
